<template>
  <div class="home-page">
    <div class="modal" v-if="isShow" @click="hideModal()" @touchmove.prevent>
      <div class="content">
        <div class="swipe">
          <mt-swipe :auto="0" @change="handleChange" :defaultIndex="certIndex">
            <mt-swipe-item v-for="item in certs" :key="item">
              <img :src="item">
            </mt-swipe-item>
          </mt-swipe>
        </div>
      </div>
      <div class="cover"></div>
    </div>

    <div class="main-wrapper">

      <mt-header fixed title="果师兄" style="background:#ffffff;color:#262626;font-size:20px;height: 50px"></mt-header>
      
      <div class="scroll-wrapper">
        <div class="scroll-content">
          <div class="swipe">
            <mt-swipe :auto="4000">
              <mt-swipe-item v-for="item in bannerList" :key="item">
                <img :src="item">
              </mt-swipe-item>
            </mt-swipe>
          </div>

          <div class="notice" v-if="notice">
            <img src="../assets/images/home_broadcast@3x.png">
            <marquee class="text" direction="left">{{notice}}</marquee>
          </div>

          <div class="primary-items">
              <div class="list-content integrated-service">
                <div class="goods-item newline" v-for="item in primaryItems" :key="item.gid" :gid="item.gid" :title="item.description" @click="goPrimaryService(item)">
                  <img :src="item.primary_icon" class="item_logo"/>
                  <span class="item_title" v-cloak>{{item.title}}</span>
                </div>
              </div>
          </div>
          <div class="contact-wrapper">
            <div class="content" v-for="(item,index) in otherItems" :key="item.cid">
                <div class="category" :class="item.cid==='1'?'blue':item.cid==='2'?'green':'orange'" @click="goServicePage(item.cname,index+1)">
                  <h2>{{item.cname}}</h2>
                  <p>{{item.remark}}</p>
                  <span class="btn" :class="item.cid==='1'?'blue':item.cid==='2'?'green':'orange'">
                    全部服务
                    <i class="arrow"></i>
                  </span>
                </div>
                <ul class="goods-list">
                  <li class="goods" v-for="it in item.goods" :key="it.ghash" @click="goPrimaryService(it)">
                    <img :src="it.category_icon">
                    <span>{{it.title}}</span>
                  </li>
                </ul>
            </div>
          </div>

          <div class="gray-bar"></div>

          <!-- <div class="article">
            <div class="up">
              <div class="middle-line">
                <div class="dotted-line"></div>
              </div>
              <div class="details">
                <a @click="goArticle(recover_page_url,'数据恢复越早越好 越早几率越高')" class="detail">
                  <img src="../assets/images/home_characteristic_recovery@3x.png">
                  <span>数据恢复越早越好</span>
                  <span>越早恢复几率越高</span>
                </a>
                <a class="detail" @click="goEngineers()">
                  <img src="../assets/images/home_characteristic_1to1@3x.png">
                  <span>资深工程师1对1</span>
                  <span>为您提供专业远程服务</span>
                </a>
              </div>
            </div>
            <div class="down">
              <a v-for="item in scenario_pages" :key="item.id" @click="goArticle(item.url,item.title)">
                <img :src="item.thumb">
              </a>
            </div>
          </div>

          <div class="gray-bar"></div> -->

          <!-- <div class="cert-wrap">
            <h2>品牌保障</h2>
            <div class="cert-box">
              <ul class="certs">
                <li v-for="(item,index) in certs" :key="item">
                  <img :src="item" @click="showModal(index)">
                </li>
              </ul>
            </div>
          </div> -->

          <div class="promise">
            <h2>双倍赔付承诺</h2>
            <!-- <span @click="goArticle(promise_url,'双倍赔付承诺说明')">详细标准</span> -->
            <p>{{guarantee}}</p>
          </div>

          <div class="promise noborder">
            <h2>团队介绍</h2>
            <!-- <span @click="goArticle(team_url,'营业执照')">营业执照</span> -->
            <p>{{team}}</p>
          </div>

          <CopyrightFooter></CopyrightFooter>
        </div>
        
      </div>
      
    
      <Footer_></Footer_>

    </div>

  </div>
</template>
<script>
import Footer_ from './Footer.vue';
import ServiceSteps from './modules/ServiceSteps';
import ServiceFeatures from './modules/ServiceFeatures';
import CopyrightFooter from './modules/CopyrightFooter'
import { Header, swipe } from 'mint-ui';
import _ from 'lodash';

export default {
  metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
  },
  data(){
    return{
      bannerList: [],
      primaryItems: [],
      otherItems: [],
      certs: [],
      guarantee: "",
      team: "",
      notice: "",
      isShow: false,
      scenario_pages: [],
      recover_page_url: '',
      timer: {},
      app_id: window.config.appid,
      promise_url: window.config.API_URL1+'/apph5/page/guarantee?app_id='+window.config.appid,
      team_url: window.config.API_URL1+ '/apph5/page/trading?app_id='+window.config.appid,
      certIndex: 0,

      code:"",
      goodsList:[],//商品列表
      zhgoodsList:[],//综合商品列表
      H5_URL:window.config.H5_URL,
      service_url:window.config.H5_URL +'/apph5/page/summary',
      question_url:window.config.H5_URL +'/apph5/page/question',
      m_guoshixiong_home: {
        'download_channel': "m.gsx.home",
        'download_channel_name': "首页下载模块-立即下载",
      },
      ios:true
    }
  },
  mounted(){
  },
  created(){
    let vm = this
    this.getBanner();
    this.getGoods()
    this.ios = this.isIos();
    this.set_distinct_id()
  },
  methods:{
      handleChange(index){
        this.sa_m_qualification(
          window.location.href,
          this.certs[index]
        )
      },
      getGoodsDetail(gid,cb){
        var info = {
            api_version : window.config.api_version,
            gid: gid
        }
        this.$store.dispatch("getGoodsInfo",info).then((res)=>{
          let result = res.data
          if(result.code == 0){
            let goods = res.data.res.data.goods
            this.sa_m_good_selected(goods.description,goods.category,window.location.href)
            let service_type = res.data.res.data.ui_version
            cb(service_type)
          }
        })
      },
      goEngineers(){
        if(this.enable_1v1_service == '1'){
          this.sa_g_service_advantage('资深工程师1v1')
          this.$router.push({name:"engineerList"})
        }
        
      },
      goPrimaryService(params){
        let that = this
        this.getGoodsDetail(params.gid,function(data){
          if(data=='v1'){
            that.$router.push({name:"purchase_service",query:{gid:params.gid,allow_chat:params.allow_chat}})
          }else if(data=='v2') {
            that.$router.push({name:"primary",query:{gid:params.gid,allow_chat:params.allow_chat}})
          }
        })
      },
      goArticle(url,title){
        if(title == '双倍赔付承诺说明'){
          this.sa_m_click_promise_detail(window.location.href)
        }
        if(title == '营业执照'){
          this.sa_m_business_licence(window.location.href)
        }
        if(title == '数据恢复越早越好 越早几率越高'){
          this.sa_g_service_advantage('数据恢复越早越好 越早几率越高')
        }
        if(title == '您的数据真的彻底删除了吗？'){
          this.sa_g_aggregation(url,'4')
        }
        if(title == '数据恢复原理深度解析'){
          this.sa_g_aggregation(url,5)
        }
        
        this.$router.push({name:"article",query:{url:url,title:title}})
      },
      goServicePage(cname,index){
        this.sa_m_click_all_service(cname)
        this.$router.push({name:"service",query:{index:index}})
      },
      showModal(index){
        this.sa_m_qualification(
          window.location.href,
          this.certs[index]
        )
        this.certIndex = index
        this.isShow = true;
      },
      hideModal(){
        this.isShow = false
      },
      getBanner(){
        let info = {
          app_id: '30001081'
        }
        this.$store.dispatch("getSystemConfig",info).then((res)=>{
          this.bannerList = res.data.res.home_banner.iphone8p
          this.certs = res.data.res.brand_certificate
          this.guarantee = res.data.res.app_text.service_guarantee
          this.enable_1v1_service = res.data.res.app_text.enable_1v1_service
          this.recover_page_url = res.data.res.app_text.recover_page_url
          this.team = res.data.res.app_text.about_our_team
          this.notice = res.data.res.app_text.official_notice
          let scenario_pages = res.data.res.scenario_pages
          this.scenario_pages = scenario_pages.slice(0,2)
        })
      },
      getGoods(){
        var info = {
            api_version : window.config.api_version,
            app_id: window.config.appid
        }
        this.$store.dispatch("getHomeGoods",info).then((res)=>{
          this.primaryItems = res.data.res.primary_items
          let category_sort = res.data.res.category_sort
          let items = res.data.res.items
          for(let i in category_sort){
            let index = category_sort[i]
            let el = _.find(items,function(o){
              return o.cid == index
            })
            if(el){
              this.otherItems.push(el)
            }
          }
        })
      },
      isIos(){
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        return isiOS
      }
  },
  filters:{
     hexToRgba(hex) { 
       let opacity = 0.5;
        return "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + opacity + ")"; 
      },
    
  },
  components:{
    swipe,
    Header,
    Footer_,
    ServiceSteps,//服务流程
    ServiceFeatures,//服务优势,
    CopyrightFooter,//CopyrightFooter
  }
}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// src/components/Home.vue